import { bookService, projectService } from '@/services'
import { thirteenth, fourteenth } from './defaultTeamProjects'
import { generateHTML } from '@/core/helper-functions'

export default async (commit, settings) => {
  // create book
  const book = await bookService.create({
    title: 'Website redesign',
    subTitle: 'Everybody knows the website needs a fresh lick of paint',
    color: 'light-green'
  })

  // create thirteenth project
  commit('loading', true)

  await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Roadmap',
    icon: 'racing-car',
    parentId: null,
    body: thirteenth(),
    html: generateHTML(thirteenth(), settings, 'Roadmap')
  })

  // create fourteenth project
  commit('loading', true)

  await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'To-dos',
    icon: 'check-mark',
    parentId: null,
    body: fourteenth(),
    html: generateHTML(fourteenth(), settings, 'To-dos')
  })
}
